<template>
    <i :class="mainClass"/>
</template>

<script>
export default {
    props: {
        src: {
            default: '',
            type: String
        }
    },
    computed: {
        mainClass() {
            return 'icon ' + this.src
        }
    }
}
</script>

<style lang="stylus">
@import "~themes/variables";

.icon
    pointer-events none
</style>



// WEBPACK FOOTER //
// src/components/commons/icon/Icon.vue